import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function TermsOfService() {
  return (
    <main className="min-h-screen bg-slate-100 dark:bg-slate-900 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/auth">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Назад к авторизации
          </Button>
        </Link>
        
        <div className="bg-white dark:bg-slate-800 rounded-3xl shadow-xl p-8 md:p-12">
          <h1 className="text-3xl font-bold text-slate-800 dark:text-white mb-8">
            Пользовательское соглашение
          </h1>
          
          <div className="prose dark:prose-invert max-w-none space-y-6 text-slate-600 dark:text-slate-300">
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Дата вступления в силу: 5 декабря 2025 года
            </p>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                1. Общие положения
              </h2>
              <p>
                Настоящее Пользовательское соглашение (далее — «Соглашение») регулирует отношения между 
                владельцем платформы Travel Ease (далее — «Администрация») и пользователем сети Интернет 
                (далее — «Пользователь»), использующим сервис управления туристическим бизнесом Travel Ease 
                (далее — «Сервис»).
              </p>
              <p>
                Использование Сервиса означает безоговорочное согласие Пользователя с настоящим Соглашением 
                и указанными в нем условиями. В случае несогласия с этими условиями Пользователь должен 
                воздержаться от использования Сервиса.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                2. Предмет соглашения
              </h2>
              <p>
                Администрация предоставляет Пользователю доступ к Сервису, который включает следующие функции:
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Ведение аналитики продаж и финансовых операций</li>
                <li>Управление контактами клиентов с поддержкой шифрования данных</li>
                <li>Корпоративный чат с end-to-end шифрованием сообщений</li>
                <li>Интеграция с мессенджерами (Telegram, WhatsApp)</li>
                <li>Подбор туров через агрегаторы</li>
                <li>Система задач и поддержки</li>
                <li>Панель управления для руководителей и администраторов</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                3. Права и обязанности Пользователя
              </h2>
              <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-2">
                3.1. Пользователь имеет право:
              </h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Использовать все доступные функции Сервиса в рамках предоставленной подписки</li>
                <li>Получать техническую поддержку через систему тикетов</li>
                <li>Экспортировать свои данные в форматах Excel и PowerPoint</li>
                <li>Управлять настройками конфиденциальности и шифрования</li>
              </ul>
              
              <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-2 mt-4">
                3.2. Пользователь обязуется:
              </h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Не передавать учетные данные третьим лицам</li>
                <li>Не использовать Сервис для противоправных действий</li>
                <li>Не нарушать работоспособность Сервиса</li>
                <li>Соблюдать конфиденциальность данных клиентов и коллег</li>
                <li>Не осуществлять попытки несанкционированного доступа к данным других пользователей</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                4. Права и обязанности Администрации
              </h2>
              <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-2">
                4.1. Администрация имеет право:
              </h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Изменять функциональность Сервиса без предварительного уведомления</li>
                <li>Блокировать доступ Пользователя при нарушении условий Соглашения</li>
                <li>Приостанавливать работу Сервиса для проведения технических работ</li>
                <li>Изменять условия подписки и тарифы</li>
              </ul>
              
              <h3 className="text-lg font-medium text-slate-700 dark:text-slate-200 mb-2 mt-4">
                4.2. Администрация обязуется:
              </h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Обеспечивать работоспособность Сервиса в режиме 24/7 с допустимым временем простоя не более 1% в месяц</li>
                <li>Защищать персональные данные Пользователей в соответствии с Политикой конфиденциальности</li>
                <li>Уведомлять Пользователей о существенных изменениях в работе Сервиса</li>
                <li>Оказывать техническую поддержку</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                5. Подписка и оплата
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Доступ к Сервису предоставляется на основании активной подписки</li>
                <li>Подписка может быть назначена индивидуально или в рамках организации</li>
                <li>По истечении срока подписки доступ к Сервису автоматически блокируется</li>
                <li>Администрация не осуществляет возврат средств за неиспользованный период подписки</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                6. Конфиденциальность и безопасность
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Контактные данные клиентов шифруются в базе данных</li>
                <li>Приватные чаты поддерживают end-to-end шифрование (опционально)</li>
                <li>Пользователь несет ответственность за сохранность ключей шифрования</li>
                <li>При потере ключей шифрования восстановление зашифрованных данных невозможно</li>
                <li>Администрация не имеет доступа к содержимому зашифрованных сообщений</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                7. Интеллектуальная собственность
              </h2>
              <p>
                Все права на Сервис, включая программный код, дизайн, товарные знаки и контент, 
                принадлежат Администрации. Использование материалов Сервиса без письменного согласия 
                Администрации запрещено.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                8. Ограничение ответственности
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Сервис предоставляется «как есть» без гарантий пригодности для конкретных целей</li>
                <li>Администрация не несет ответственности за убытки, связанные с использованием Сервиса</li>
                <li>Администрация не несет ответственности за потерю данных в результате действий Пользователя</li>
                <li>Пользователь самостоятельно обеспечивает резервное копирование критически важных данных</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                9. Изменение условий Соглашения
              </h2>
              <p>
                Администрация оставляет за собой право изменять условия настоящего Соглашения. 
                Продолжение использования Сервиса после внесения изменений означает согласие 
                Пользователя с новыми условиями.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-slate-800 dark:text-white mb-3">
                10. Заключительные положения
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Настоящее Соглашение вступает в силу с момента начала использования Сервиса</li>
                <li>Все споры разрешаются путем переговоров, а при недостижении согласия — в судебном порядке</li>
                <li>Признание недействительным одного из положений Соглашения не влечет недействительность остальных положений</li>
              </ul>
            </section>

            <section className="border-t border-slate-200 dark:border-slate-700 pt-6 mt-8">
              <p className="text-sm text-slate-500 dark:text-slate-400">
                По всем вопросам, связанным с настоящим Соглашением, обращайтесь через систему поддержки в Сервисе.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
}
